import React from 'react';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import {FormFive, InfoMedia} from '../../components';
import {Link} from "react-router-dom";

const ContactTwo = ({ initialService, ...restProps}) => (
    <div {...restProps}>
        <div className="container">
            <div className="row">
                <div className="col-lg-6 mb-30">
                    <div className="contact-box">
                        <h3 className="contact-box__title h4">Office Addresses</h3>
                        <p className="contact-box__text">For all inquiries, support, and assistance, please contact one of our
                            offices.</p>
                        <div className="info-media">
                            <InfoMedia
                                icon="fal fa-phone-alt"
                                title="Phone Number & Email"
                                info={<><a className={"custom-link"} href="tel:+971585703053">+971 585703053</a>
                                    <br/>
                                    <a className={"custom-link"} href="mailto:sales@esyncross.com">sales@esyncross.com</a></>}
                            />
                        </div>

                            <InfoMedia
                                icon="far fa-map-marker-alt"
                                title="Our Office Addresses"
                                info={<>
                                    <a className={"custom-link"} target={'_blank'} href="https://www.google.com/maps/place/Sharjah+Media+City+(Shams)/@25.2784547,55.6762004,913m/data=!3m1!1e3!4m6!3m5!1s0x3ef5929a229f1c75:0xb28ae30eb6bb813a!8m2!3d25.2784456!4d55.6782898!16s%2Fg%2F11c6038qjv?entry=ttu&g_ep=EgoyMDI1MDExNS4wIKXMDSoASAFQAw%3D%3D">
                                        {"Sharjah Media City, Sharjah, UAE"}
                                    </a>
                                    <br/>
                                    <a className={"custom-link"} target={'_blank'}  href="https://www.google.com/maps/place/The+Iridium+Building/@25.1186507,55.2077128,399m/data=!3m1!1e3!4m14!1m7!3m6!1s0x3e5f6bc1af8e1daf:0x6388c09f82918589!2sThe+Iridium+Building!8m2!3d25.1186337!4d55.2072461!16s%2Fg%2F11cs6c9zdr!3m5!1s0x3e5f6bc1af8e1daf:0x6388c09f82918589!8m2!3d25.1186337!4d55.2072461!16s%2Fg%2F11cs6c9zdr?entry=ttu&g_ep=EgoyMDI1MDgxMy4wIKXMDSoASAFQAw%3D%3D">
                                        {"Office 209, IRIDIUM , Al Barsha,Dubai, UAE"}
                                    </a>
                                </>}
                            />
                        <InfoMedia
                            icon="fal fa-ticket-alt"
                            title="Support Services"
                            info={<>
                                <a className={"custom-link"} target={'_blank'} href="https://esyncross.freshdesk.com/support/tickets/new">Login to support portal</a>
                                <br/>
                                <a className={"custom-link"} target={'_blank'}  href="https://esyncross.freshdesk.com/support/login">Submit new ticket</a>
                            </>}
                        />
                    </div>
                </div>
                <div className="col-lg-6 mb-30">
                    <div className="contact-box">
                        <h3 className="contact-box__title h4">Leave a Message</h3>
                        <p className="contact-box__text">We’re Ready To Help You</p>
                        <FormFive initialService={initialService}/>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default ContactTwo;